import React, { useEffect, ComponentProps } from 'react';
import { useAuthentication } from '../../../v2/LoginPageV2';
import { ProgressBreadcrumbList, ProgressBreadcrumbListTheme, ProgressBreadcrumb } from '@apply/components';
import '../../scss/_applicationEntrySidebar.scss';

type ProgressBreadcrumbProps = ComponentProps<typeof ProgressBreadcrumb>;
export interface ApplicationEntrySidebarProps {
    crumbs: ProgressBreadcrumbProps[];
    currentCrumb: number;
    printMode?: boolean;
}

export const ApplicationEntrySidebar: React.FC<ApplicationEntrySidebarProps> = ({ crumbs, currentCrumb, printMode }) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <div className='applicationEntrySidebar'>
                <div className='applicationEntrySidebar-contentWrapper'>
                    <div className='applicationEntrySidebar-logo'>
                        <img
                            src='/assets/img/logo.webp.html'
                            alt='Builder Finance'
                            width='116px'
                        />
                    </div>
                    <div className='applicationEntrySidebar-descriptor'>Apply</div>
                    <div className='applicationEntrySidebar-progressBreadcrumb-vertical'>
                        <ProgressBreadcrumbList
                            id='applicationEntrySidebarVerticalBreadcrumb'
                            theme={ProgressBreadcrumbListTheme.Blue}
                            activeCrumbNumber={currentCrumb}
                            crumbs={crumbs}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
